module.exports = __webpack_public_path__ + "img/plane-prop.3e7658de.svg";